<template>
  <div
    v-if="memberInfo && memberInfo.child"
    class="member-module memberInfo"
    :class="{'en-member-module': isEnglish}"
  >
    <h2
      class="title"
      :class="{spread: !spread}"
      @click="handleSpread"
    >
      <span class="name">{{ $t('message["346"]') }}</span>
      <span
        class="operate"
      >
        <span
          v-if="spread"
          class="text"
        >
          {{ $t('message["1106"]') }}
        </span>
        <span
          v-else
          class="text"
        >
          {{ $t('message["1564"]') }}
        </span>
        <i
          v-if="spread"
          class="iconfont iconicon-test15"
        />
        <i
          v-else
          class="iconfont iconicon-test14"
        />
      </span>
    </h2>
    <div
      class="content-box"
      :class="{spread: !spread}"
    >
      <div class="detail clearfix">
        <a-form-item
          v-for="(item, index) in memberInfo.child"
          v-show="item.fieldkey !== 'code'"
          :key="index"
          class="clearfix"
        >
          <template slot="label">
            <a-tooltip
              v-if="isEnglish"
              overlay-class-name="form-label-tooltip"
              trigger="hover"
            >
              <span
                v-if="$getStrleng(item.fieldname) > 8*2"
                slot="title"
              >
                {{ item.fieldname }}
              </span>
              {{ (item.fieldname && $substr(item.fieldname, 8)) || '- -' }}
            </a-tooltip>
            <template v-else>
              {{ item.fieldname }}
            </template>
          </template>
          <div
            v-if="showMemberItem(item)"
            class="value clearfix"
          >
            <!-- truename -->
            <!-- follow_status 跟进状态 0共享信息 1已分配到人 2待分配 3待指派 4需要重新分配 5已归档 -->
            <!-- <span class="truename-box"> -->
            <a-tooltip
              v-if="item.fieldkey === 'follow' || item.fieldkey === 'dev' || item.fieldkey === 'input' || item.fieldkey === 'audit'"
              overlay-class-name="td-userid-tooltip"
              trigger="hover"
            >
              <template v-if="item.fieldkey === 'follow' || item.fieldkey === 'dev'">
                <span
                  v-if="item.info.truename"
                  slot="title"
                  class="read-box"
                >
                  {{ item.info.truename }}{{ item.info.isread ? auditTit[0] : auditTit[1] }}
                </span>
                <i
                  v-if="item.info.truename"
                  :class="['is-read', { 'no': !item.info.isread, 'yes': item.info.isread }]"
                />
                <span v-if="item.info.status === 0">{{ $t('message["394"]') }}</span>
                <span v-else-if="item.info.status === 2 || item.info.status === 4">{{ $t('message["139"]') }}</span>
                <span v-else-if="item.info.status === 3">{{ $t('message["146"]') }}</span>
                <span v-else-if="item.info.status === 5">{{ $t('message["1460"]') }}</span>
                <span
                  v-else
                  class="truename"
                >{{ (item.info.truename && $substr(item.info.truename, 8)) || '- -' }}</span>
              </template>
              <template v-else>
                <span
                  v-if="item.info.truename && $getStrleng(item.info.truename) > 8 * 2"
                  slot="title"
                >
                  {{ item.info.truename }}
                </span>
                <span
                  class="truename"
                  :style="{cursor: item.info.truename && $getStrleng(item.info.truename) > 8 * 2 ? 'pointer' : 'text'}"
                >{{ (item.info.truename && $substr(item.info.truename, 8)) || '- -' }}</span>
              </template>
            </a-tooltip>
            <!-- <em v-else>{{ item.info.truename || '- -' }}</em> -->
            <!-- </span> -->
            <!-- group -->
            <span
              v-if="item.info.rolename || item.info.groupname"
              class="fs-gray ml-8 group"
            >[
              <a-tooltip
                v-if="isEnglish"
                overlay-class-name="form-label-tooltip"
                trigger="hover"
              >
                <span
                  slot="title"
                >
                  {{ item.info.rolename || '--' }}
                  <template v-if="item.info.groupname && item.info.rolename">/</template>
                  <template>{{ item.info.groupname || '' }}</template>
                </span>
                <span class="role-group">
                  <em class="rolename">{{ item.info.rolename || '--' }}</em> <em v-if="item.info.groupname && item.info.rolename">/</em> <em class="groupname">{{ item.info.groupname || '' }}</em>
                </span>
              </a-tooltip>
              <template v-else>
                <em class="rolename">{{ item.info.rolename || '--' }}</em> <em v-if="item.info.groupname && item.info.rolename">/</em> <em class="groupname">{{ item.info.groupname || '' }}</em>
              </template>
              ]</span>
            <!-- 跟进人员按钮 -->
            <template v-if="item.fieldkey === 'follow'">
              <span
                v-if="permissionInfo.is_show_assign"
                class="btn-text"
                @click="onClickFollow('assign', item)"
              >{{ $t('message["1604"]') }}</span>
              <span
                v-if="permissionInfo.is_show_receive"
                class="btn-text"
                @click="onClickFollow('receive', item)"
              >{{ $t('message["613"]') }}</span>
              <span
                v-if="permissionInfo.is_show_transfer"
                class="btn-text"
                @click="onClickFollow('transfer', item)"
              >{{ $t('message["1645"]') }}</span>
              <span
                v-if="permissionInfo.is_show_allocate"
                class="btn-text"
                @click="onClickFollow('allocate', item)"
              >{{ $t('message["298"]') }}</span>
            </template>
          </div>
          <div
            v-else
            class="string-item"
          >
            <span class="value">
              {{ item.fielddesc || item.fieldvalue }}
            </span>
          </div>
        </a-form-item>
      </div>

      <!-- 重新分配 -->
      <div
        v-if="memberInfo.follow_status === 4 && memberInfo.reallocate_truename"
        class="re-assign member-bottom"
      >
        <div
          ref="reAssignLeft"
          class="top"
        >
          <span class="time">{{ moment(memberInfo.reallocate_time * 1000).format('YYYY-MM-DD HH:mm:ss') }} {{ memberInfo.reallocate_truename }}</span>
          <span
            v-if="memberInfo.reallocate_rolename || memberInfo.reallocate_groupname"
            class="fs-gray ml-8"
          >[<em class="rolename">{{ memberInfo.reallocate_rolename || '--' }}</em> <em v-if="memberInfo.reallocate_groupname && memberInfo.reallocate_rolename">/</em> <em class="groupname">{{ memberInfo.reallocate_groupname }}</em>] </span>
          <span>{{ $t('message["1041"]') }}：</span>
        </div>
        <div
          class="content"
          :style="{'padding-left': reAssignLeftWidth }"
        >
          {{ memberInfo.reallocate_reason }}
        </div>
      </div>
      <!-- 归档 -->
      <div
        v-else-if="memberInfo.follow_status === 5"
        class="archive-desc member-bottom"
      >
        <span class="time">{{ moment(memberInfo.archive_time * 1000).format('YYYY-MM-DD HH:mm:ss') }} {{ memberInfo.archive_truename }}</span>
        <span
          v-if="memberInfo.archive_rolename || memberInfo.archive_groupname"
          class="fs-gray ml-8"
        >[<em class="rolename">{{ memberInfo.archive_rolename || '--' }}</em> <em v-if="memberInfo.archive_groupname && memberInfo.archive_rolename">/</em> <em class="groupname">{{ memberInfo.archive_groupname }}</em>] </span>
        <span>{{ $t('message["420"]') }}</span>
        <span v-if=" memberInfo.archive_reason">：{{ memberInfo.archive_reason }}</span>
      </div>
    </div>
    <fllow-modal
      :visible.sync="showFollowModal"
      :inquiry-id="inquiryId"
      :type="type"
      :data="currentItem"
      :groupid="followGroupid"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import FllowModal from './modal/FllowModal'
import { getLang } from '@/lib/storage'

export default {
  components: {
    FllowModal
  },
  /* props: {
    data: {
      type: Object,
      default: () => { }
    }
  }, */
  data () {
    return {
      showFollowModal: false,
      type: '',
      currentItem: {},
      spread: false,
      reAssignLeftWidth: 0
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),
    from () {
      return this.$route.query.from
    },
    inquiryId () {
      return this.$route.params.inquiryId
    },
    followGroupid () {
      const { follow_groupid: followGroupid } = this.memberInfo || {}
      return followGroupid
    },
    auditTit () {
      return this.$t('message["1451"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  /* watch: {
    permissionInfo: {
      handler (val) {
        if (!val) return

        const { is_show_assign: isShowAssign, is_show_receive: isShowReceive, is_show_allocate: isShowAllocate } = val || {}

        const { follow_truename: followTruename } = this.memberInfo

        if ((isShowAssign || isShowReceive || isShowAllocate) && !followTruename) {
          this.spread = true
        } else {
          this.spread = false
        }
      },
      immediate: true
    }
  }, */

  mounted () {
    this.$nextTick(() => {
      let w = (this.$refs.reAssignLeft && this.$refs.reAssignLeft.offsetWidth) || 0
      this.reAssignLeftWidth = w + 'px'
    })
  },

  methods: {
    moment,
    getLang,
    onClickFollow (type, item) {
      this.type = type
      this.showFollowModal = true
      this.currentItem = item
    },
    showMemberItem (item) {
      return item.fieldkey === 'input' || item.fieldkey === 'dev' || item.fieldkey === 'audit' || item.fieldkey === 'follow'
    },
    handleSpread () {
      if (this.spread) {
        this.spread = false
      } else {
        this.spread = true
      }
      document.body.style.overflow = 'hidden'
      setTimeout(() => {
        this.$bus.$emit('getInnerHeight')
      }, 30)
    }
  }
}
</script>

<style lang="scss" scoped>
.member-module {
  width: 1280px;
  margin: 0 auto;
  padding: 16px 40px;
  background-color: #fff;
  border-bottom: solid 1px $gray4;
  em {
    font-style: normal;
  }
  h2.title {
    width: auto; // 100px;
    margin: 0;
    font-size: 18px;
    cursor: pointer;
    .name {
      float: left;
      height: 99%;
      font-weight: bold;
    }
    .operate {
      margin-left: 16px;
      .text {
        margin-right: 2px;
        color: #5077AA;
        font-size: 14px;
      }
      i.iconfont {
        font-size: 12px;
        color: #d8d8d8;
      }
      // float: right;
    }
  }
  /* .detail {
    padding-left: 8px;
  } */
  .content-box {
    overflow: hidden;
    height: auto;
    margin-top: 18px;
    transition: all 1s;
    &.spread {
      height: 40px;
    }
  }
  .ant-form-item {
    width: 33%;
    float: left;
    margin-bottom: 16px;
  }
  .btn-text {
    margin-left: 8px;
  }
  .member-bottom {
    padding: 16px 24px;
    border-top: solid 1px $gray4;
  }
  .re-assign {
    width: 100%;
    .top {
      float: left;
    }
    .content {
      position: relative;
      top: -3px;
      color: $gray2;
      line-height: 1.5;
    }
  }
}
.en-member-module::v-deep {
  .ant-form-item-label {
    width: 120px !important;
    text-align: right;
    // text-overflow: ellipsis;
  }
  .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-control-wrapper::before {
    content: ':';
    position: absolute;
    top: 5px;
    left: 100px;
    color: #666;
  }
  .ant-form-item-control-wrapper {
    padding-left: 120px !important;
    .role-group {
      max-width: 80px;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
    }
    .value > span {
      height: 32px;
      overflow: hidden;
    }
  }
}
</style>
<style lang="scss">
 .member-module.memberInfo {
  .ant-form-item-label {
    width: 80px;
    text-align: right;
  }
  .ant-form-item-control-wrapper {
    padding-left: 80px;
  }
  .value {
    & > span {
      float: left;
    }
  }
  .is-read {
    display: inline-block;
    position: relative;
    font-size: 0;
    transform: scale(0.5);
    transform-origin: center left;
    &.no {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 8px;
      background: #4CA0F2;
    }
    &.yes {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 8px;
      background: #D6D6D6;
    }
    /* &.iconfont {
      font-size: 18px;
      color: #D6D6D6;
      vertical-align: middle;
    } */
  }
  .is-read + .truename {
    cursor: pointer;
    margin-left: -4px;
    // vertical-align: middle;
  }
  /* .truename + .group {
    vertical-align: middle;
  } */
  /* .group + .btn-text {
    vertical-align: middle;
  } */
}
.form-label-tooltip, .td-userid-tooltip {
  .ant-tooltip-arrow {
    display: none;
  }
}
</style>
